import { mapProjectRates } from '~/modules/rateCard/advancedRateCard/components/hooks/utils';
import { CostOverrideType } from '../CostOverrideType';

export const mapCostOverrideRates = (
  projectRates,
  projectDimensions,
  loadingMore
) =>
  mapProjectRates(projectRates, projectDimensions, loadingMore).map(rate => ({
    ...rate,
    type: rate.type ?? CostOverrideType.HOURLY_RATE,
    percent: rate.percent ?? 0
  }));

export default mapCostOverrideRates;
